import React from "react";
import styles from "./AddUserLicense.module.css";
import { useNavigate } from "react-router-dom";
import { SubmitButton, TextComponent } from "../../../../../components";
import { FaRegCheckCircle } from "react-icons/fa";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";

const AddUserLicense = () => {
  const navigate = useNavigate();

  const LicenseData = [
    {
      id: 1,
      name: "Supervisor",
      price: "$35",
      type: "License Packs",
      Features: ["1 Supervisor license", "4 Staff Member licenses"],
    },
    {
      id: 2,
      name: "Standalone",
      price: "$5",
      type: "Staff License",
      Features: ["Add individual license"],
    },
    {
      id: 3,
      name: "Supervisor",
      price: "$35",
      type: "License Packs",
      Features: ["Add individual license"],
    },
  ];

  const renderLicense = (item, index) => {
    return (
      <div className={styles.AO_listItem} key={item.id}>
        <div className={styles.row}>
          <div>
            <TextComponent
              text={item?.name}
              padding={"0px"}
              className={styles.Name}
            />
            <TextComponent
              text={item?.type}
              padding={"0px"}
              className={styles.type}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextComponent
              text={item?.price}
              padding={"0px"}
              className={styles.price}
            />
            <TextComponent text={"per month"} padding={"0px"} />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.CardSubList}>
            {item?.Features?.map((element, index) => {
              return (
                <div className={styles.list} key={index}>
                  <FaRegCheckCircle color="#EF710A" size={16} />
                  <TextComponent text={element} className={styles.ItemText} />
                </div>
              );
            })}
          </div>

          <SubmitButton
            btnContainerClass={styles.btnContainer}
            btnClass={styles.btnClass}
            onClick={() =>
              navigate("/AdminBuisnessManagement/SelectPaymentMethod")
            }
            title={"Add License "}
            primary
          />
        </div>
      </div>
    );
  };

  return (
    <div className={styles.mainCont}>
      <HeaderComponent showBackIcon={true} heading={"Add User License"} />

      <div className={styles.subCont}>
        {LicenseData.map((item, index) => renderLicense(item, index))}
      </div>
    </div>
  );
};

export default AddUserLicense;
